import { useRouter } from 'next/router'

import { LoadingOverlay } from '@/components/ui'
import { ROUTE } from '@/const'
import { useSession } from '@/hooks/features/auth'

import { withLimitedMode } from '../WithLimitedMode'
import { WithAuthProps } from './type'

/**
 * ログインユーザーのみアクセスを許可
 * 非ログインユーザーがアクセスを試みた場合はログインページへリダイレクト
 */
export const withAuth = (PageComponent: WithAuthProps) => {
  const AuthenticatedPage = (props: any) => {
    const router = useRouter()
    const { isAuthenticated, isLoading, isPasswordResetRequired } = useSession()

    if (isAuthenticated) {
      return <PageComponent {...props} />
    }

    if (isLoading) {
      return <LoadingOverlay isLoading={true} />
    }

    if (isPasswordResetRequired) {
      router.push(ROUTE.resetPassword)
      return null
    }

    router.push(ROUTE.login)
    return null
  }

  return withLimitedMode(AuthenticatedPage)
}
